function getApiBase() {
  return process.env.NODE_ENV === "development"
    ? `http://localhost:${process.env.PORT}`
    : ""
}

module.exports = { getApiBase }
